import useFeatureFlagValue from '@/components/analytics/hooks/useFeatureFlagValue';

export const CR257_IMPROVE_WEB_SUBURB_SELECTION_FLAG = 'cr-257-improve-web-suburb-selection';

/**
 * CR-257: Improve web suburb selection.
 *
 * Control keeps the current signup flow (no suburb step). True serves the app-like mandatory chip suburb picker on all signup surfaces. The field is hidden when a city does not have enough suburbs to choose from.
 *
 * @see https://firsttable.atlassian.net/browse/CR-257
 * @see https://firsttable.atlassian.net/browse/PD-6553
 * @see https://app.growthbook.io/features/cr-257-improve-web-suburb-selection
 * @see https://app.growthbook.io/experiment/exp_19g6mmszio039
 */
export default function useCR257ImproveWebSuburbSelectionExperiment(): boolean {
  return useFeatureFlagValue(CR257_IMPROVE_WEB_SUBURB_SELECTION_FLAG, false) === true;
}
